import { createContext, useContext } from 'react';
import type { TenantRole } from '@provalia/shared';
import type { Me } from './api';

export interface PortalContextValue {
  me: Me;
  reloadMe: () => Promise<void>;
  logout: () => void;
}

export const PortalContext = createContext<PortalContextValue | null>(null);

export function usePortal(): PortalContextValue {
  const ctx = useContext(PortalContext);
  if (!ctx) throw new Error('usePortal fuera de PortalContext');
  return ctx;
}

// ── Permisos de pantalla (los de verdad los comprueba la API) ─────────────

export const isSupplier = (role: TenantRole): boolean => role === 'proveedor';
export const isStaff = (role: TenantRole): boolean => role !== 'proveedor';
/** Compras y el administrador del cliente: validan, dan de alta, gestionan usuarios. */
export const isBuyer = (role: TenantRole): boolean => role === 'compras' || role === 'cliente_admin';
export const canReceive = (role: TenantRole): boolean => role === 'recepcion' || isBuyer(role);
